import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {Staffs} from '../../../models/staff/staffs';
import {FileService} from '../../../service/file/service-file';
import {CommandUtil} from '../../../global/commandutil';

@Component({
  templateUrl: './profile.component.html'

})export class ProfileStaffsComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public picture: string;
  public avatarKey: string;
  public staffItem: Staffs= new Staffs();
  constructor( public staffsService: StaffsService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public fileService: FileService,
               public commandUtil: CommandUtil

  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      hoDem: new FormControl(),
      ten: new FormControl(),
      biDanh: new FormControl(),
      ngaySinh: new FormControl(),
      gioiTinh: new FormControl(),
      telOffice:  new FormControl(),
      telHome: new FormControl(),
      mobile: new FormControl(),
      email: new FormControl(),
      address: new FormControl(),



    });
    this.frmGroup = this.formBuilder.group({
      hoDem: ['' , Validators.compose([validateEmpty]) ],
      ten: ['' , Validators.compose([validateEmpty]) ],
      biDanh: ['', Validators.nullValidator],
      mobile: ['', Validators.nullValidator],
      ngaySinh: ['', Validators.nullValidator],
      gioiTinh: ['', Validators.nullValidator],
      telOffice: ['', Validators.nullValidator],
      telHome: ['', Validators.nullValidator],
      email: ['', Validators.nullValidator],
      address: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.id = id;
    this.isEdit = id != 0 ? true: false;
    this.staffsService.getById(id).pipe(first())
      .subscribe(x => {
        this.staffItem = x;
        this.picture = x.anh !== null && x.anh !== '' ? this.commandUtil.getUrlAvatar(x.anh): 'assets/img/avatars/1.jpg';
        this.avatarKey = x.anh !==null? x.anh.replace("/avatar/",""):"";
        this.frmGroup.patchValue(x);
      });

  }
  updateItem()
  {
    this.staffItem.mobile= this.frmGroup.value.mobile;
    this.staffItem.telOffice = this.frmGroup.value.telOffice;
    this.staffItem.telHome= this.frmGroup.value.telHome;
    this.staffItem.address = this.frmGroup.value.address;
    this.staffItem.email = this.frmGroup.value.email;
    this.staffItem.hoDem = this.frmGroup.value.hoDem;
    this.staffItem.ten = this.frmGroup.value.ten;
    this.staffItem.biDanh = this.frmGroup.value.biDanh;
    this.staffItem.ngaySinh = this.frmGroup.value.ngaySinh;
    this.staffItem.gioiTinh = this.frmGroup.value.gioiTinh;
    this.staffItem.anh = this.avatarKey;
    this.staffsService.update(this.staffItem).subscribe({
      next: (data) => {
        this.toastr.success(language.update_success_record, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;

      this.updateItem();

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      let reader: FileReader = new FileReader();

      this.fileService.upload(event.target.files[0]).subscribe(data => {
        this.avatarKey = data.fileKey;
      } );

      reader.readAsDataURL(event.target.files[0]);
      reader.onloadend = (event1) => {
        this.picture=  reader.result.toString();
      }
    }
  }
}
